const IndicatorListStyle = {
  bg: "none",
  mr: "20px",
};

const IndicatorBoxStyle = {
  display: "grid",
  gridGap: 1,
  gridTemplateColumns: ["repeat(1, 1fr)", "repeat(3, 1fr)"],
  height: 100,
};

export { IndicatorListStyle, IndicatorBoxStyle };
